//
// SortController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../../lib";
import "@sas-dvr/ltjs-commons/models/data/sorting/DataTreeSortContext";
import "@sas-dvr/ltjs-commons/models/data/sorting/DimensionalSortContext";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortContext";
import "@sas-dvr/ltjs-commons/models/data/sorting/MeasureSortContext";

var SortController = createModule("BIRD_SortController", [40397], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getRelationalSortIndices: [[3]],
        resetToDefault: [0],
        getMeasureSortsForAxis: [[1],4],
        getDimensionalSortForAxis: [1,4],
        hasRelationalSortStatement: [2],
        getRelationalSortsForAxis: [[1],4],
        hasDimensionalSortStatement: [2],
        getDataTreeSortContext: [1],
    },
    {
        createSortContext: [1,1,7,4],
    },
    ,
]);
export default SortController;
